module.exports = __webpack_public_path__ + "img/ik-detectors.f7ab5dd5.png";